import React from "react";
import { Grid, IconButton } from "@mui/material";
import { Facebook, Instagram, WhatsApp } from "@mui/icons-material";
import "./Footer.css";

const Footer = ({ enterprise }) => {
  function formatPhoneNumber(phone) {
    return phone.replace(/\D/g, ""); // Elimina todos los caracteres que no sean números
  }

  function renderHorarios(horarios) {
    return Object.entries(horarios).map(([dia, horario]) => (
      <div key={dia} style={{ marginBottom: "0.5rem" }}>
        <strong>{dia.charAt(0).toUpperCase() + dia.slice(1)}:</strong>{" "}
        {horario
          .map(({ apertura, cierre }) => {
            // Si apertura y cierre están vacíos, mostrar "Cerrado"
            if (apertura === "" && cierre === "") {
              return "Cerrado";
            }
            return `${apertura} - ${cierre}`;
          })
          .join(", ")}
      </div>
    ));
  }

  return (
    <footer
      style={{
        backgroundColor: "#222",
        color: "#fff",
        padding: "2rem 0",
        textAlign: "center",
      }}
    >
      <div className="containerFooter">
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "35%",
          }}
        >
          <h5 style={{ marginBottom: "1rem", textTransform: "uppercase" }}>
            Horarios de atención
          </h5>
          <div style={{ fontSize: "0.875rem", lineHeight: "1.5" }}>
            {enterprise?.horarios
              ? renderHorarios(enterprise.horarios)
              : "No disponible"}
          </div>
        </div>

        <Grid
          container
          justifyContent="center"
          spacing={2}
          width={"35%"}
          className="containerInfoFooter"
        >
          {/* Información General */}
          <Grid item xs={12}>
            <h4 style={{ marginBottom: "1rem", textTransform: "uppercase" }}>
              {enterprise?.name ? enterprise.name : "Autoelevadores Echarri"}
            </h4>
            <p style={{ margin: "0 auto", maxWidth: "600px" }}>
              {enterprise?.description
                ? enterprise.description
                : "Soluciones eficientes y seguras en alquiler y mantenimiento de equipos de altura. Contáctanos para obtener más información."}
            </p>
          </Grid>

          {/* Redes Sociales */}
          <Grid item xs={12}>
            <div style={{ margin: "1rem 0" }}>
              <IconButton
                href={
                  enterprise?.facebook
                    ? `https://www.facebook.com/${enterprise.facebook}/`
                    : "https://www.facebook.com/AutoelevadoresEcharrielevaciones/"
                }
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                style={{ color: "#4267B2" }}
              >
                <Facebook fontSize="large" />
              </IconButton>
              <IconButton
                href={
                  enterprise?.instagram
                    ? `https://www.instagram.com/${enterprise.instagram}/`
                    : "https://www.instagram.com/autoelevadoresecharri/"
                }
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{ color: "#E1306C" }}
              >
                <Instagram fontSize="large" />
              </IconButton>
              <IconButton
                href={`https://wa.me/${
                  enterprise?.celular
                    ? formatPhoneNumber(enterprise.celular)
                    : "5491126485397"
                }`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                style={{ color: "#25D366" }}
              >
                <WhatsApp fontSize="large" />
              </IconButton>
            </div>
          </Grid>

          {/* Derechos Reservados */}
          <Grid item xs={12}>
            <p style={{ fontSize: "0.875rem", margin: 0 }}>
              © {new Date().getFullYear()}{" "}
              {enterprise?.name ? enterprise.name : "Autoelevadores Echarri"}.
              Todos los derechos reservados.
            </p>
          </Grid>
        </Grid>

        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "35%",
          }}
        ></div>
      </div>
    </footer>
  );
};

export default Footer;
